module.exports = __webpack_public_path__ + "img/features.143bb5ab.svg";